<template>
    <div>
        <quill-editor ref="quillEditor" class="ql-editor" :value="editorData" :disabled="disabled"
                      :options="editorOption" :placeholder="placeholder" @blur="onEditorBlur($event)"
                      @click.native="handleEditAble"
                      @focus="onEditorFocus($event)"
                      @change="onEditorChange($event)"></quill-editor>
        <question-blank :show.sync="questionblankDialogVisible" @close="questionblankClose"></question-blank>
        <kity-formula :show.sync="kityformulaDialogVisible" @close="kityformulaClose"></kity-formula>
    </div>
</template>

<script>
    import request from '../../utils/request'
    import {Quill} from 'vue-quill-editor'
    import questionBlank from './questionblank/import.vue'
    import kityFormula from './kityformula/kityformula.vue'

    let Size = Quill.import('attributors/style/size')
    Size.whitelist = ['12px', '13px', '14px', '15px', '16px', '17px', '18px', '19px', '20px', '22px', '24px', '26px', '28px', '32px', '36px', '48px', '64px', '72px']
    Quill.register(Size, true)
    // toolbar标题
    const titleConfig = [
        {Choice: '.ql-insertMetric', title: '跳转配置'},
        {Choice: '.ql-bold', title: '加粗'},
        {Choice: '.ql-italic', title: '斜体'},
        {Choice: '.ql-underline', title: '下划线'},
        {Choice: '.ql-header', title: '段落格式'},
        {Choice: '.ql-strike', title: '删除线'},
        {Choice: '.ql-blockquote', title: '块引用'},
        {Choice: '.ql-code', title: '插入代码'},
        {Choice: '.ql-code-block', title: '插入代码段'},
        {Choice: '.ql-font', title: '字体'},
        {Choice: '.ql-size', title: '字体大小'},
        {Choice: '.ql-list[value="ordered"]', title: '编号列表'},
        {Choice: '.ql-list[value="bullet"]', title: '项目列表'},
        {Choice: '.ql-direction', title: '文本方向'},
        {Choice: '.ql-header[value="1"]', title: 'h1'},
        {Choice: '.ql-header[value="2"]', title: 'h2'},
        {Choice: '.ql-align', title: '对齐方式'},
        {Choice: '.ql-color', title: '字体颜色'},
        {Choice: '.ql-background', title: '背景颜色'},
        {Choice: '.ql-image', title: '图像'},
        {Choice: '.ql-video', title: '视频'},
        {Choice: '.ql-link', title: '添加链接'},
        {Choice: '.ql-formula', title: '插入公式'},
        {Choice: '.ql-clean', title: '清除字体格式'},
        {Choice: '.ql-script[value="sub"]', title: '下标'},
        {Choice: '.ql-script[value="super"]', title: '上标'},
        {Choice: '.ql-indent[value="-1"]', title: '向左缩进'},
        {Choice: '.ql-indent[value="+1"]', title: '向右缩进'},
        {Choice: '.ql-header .ql-picker-label', title: '标题大小'},
        {Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一'},
        {Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二'},
        {Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三'},
        {Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四'},
        {Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五'},
        {Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六'},
        {Choice: '.ql-header .ql-picker-item:last-child', title: '标准'},
        {Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号'},
        {Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号'},
        {Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号'},
        {Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准'},
        {Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐'},
        {Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐'},
        {Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐'},
        {Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐'}
    ]
    export default {
        name: 'inEditor',
        components: {
            questionBlank, kityFormula
        },
        props: ['value', 'placeholder', 'disabled', 'fill', 'meta'],
        data() {
            return {
                questionblankDialogVisible: false,
                kityformulaDialogVisible: false,
                editorData: '',
                editable: false,
                // 编辑器组件需要获取编辑器实例
                editorOption: {
                    modules: {
                        // 粘贴事件拦截
                        clipboard: {
                            matchers: [
                                ['img', this.handlePasteImg]
                            ],
                        },
                        toolbar: {
                            container: [
                                ['bold', 'italic', 'underline', 'strike'],    //加粗，斜体，下划线，删除线
                                ['blockquote', 'code-block'],     //引用，代码块
                                [{'list': 'ordered'}, {'list': 'bullet'}],     //列表
                                [{'script': 'sub'}, {'script': 'super'}],   // 上下标
                                [{'align': []}],    //对齐方式
                                [{'indent': '-1'}, {'indent': '+1'}],     // 缩进
                                // [{ 'direction': 'rtl' }],             // 文本方向
                                [{'size': ['12px', '13px', '14px', '15px', '16px', '17px', '18px', '19px', '20px', '22px', '24px', '26px', '28px', '32px', '36px', '48px', '64px', '72px']}], // 字体大小
                                // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],     //几级标题
                                [{'color': []}, {'background': []}],     // 字体颜色，字体背景颜色
                                // [{ 'font': [] }],     //字体
                                ['image'],    //上传图片、上传视频,'video'
                                this.fill ? ['questionblank', 'kityformula'] : ['kityformula'],
                                ['clean'],    //清除字体样式
                            ],
                            handlers: {
                                'questionblank': this.questionblankHandler,
                                'kityformula': this.kityformulaHandler,
                                image: function image() {
                                    var self = this;

                                    var fileInput = this.container.querySelector('input.ql-image[type=file]');
                                    if (fileInput === null) {
                                        fileInput = document.createElement('input');
                                        fileInput.setAttribute('type', 'file');

                                        // 可设置上传图片的格式
                                        fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
                                        fileInput.classList.add('ql-image');
                                        // 监听选择文件
                                        fileInput.addEventListener('change', function () {
                                            // 创建formData
                                            var formData = new FormData();
                                            formData.append('file', fileInput.files[0]);
                                            fileInput.value = ''
                                            request({
                                                url: '/api/file/common/upload',
                                                method: 'post',
                                                data: formData,

                                            }).then(res => {
                                                let length = self.quill.getSelection(true).index;
                                                self.quill.insertEmbed(length, 'image', res.data.uri);
                                                self.quill.setSelection(length + 1)
                                            })
                                        });
                                        this.container.appendChild(fileInput);
                                    }
                                    fileInput.click();
                                }
                            },
                        }
                    },
                    // theme: 'bubble',
                    placeholder: this.placeholder,
                },
                content: null,
                timer: null,
            }
        },
        watch: {
            value(val) {
                if (!this.editorData) {
                    return
                }

                // 外部内容发生变化时，将新值赋予编辑器
                if (val && val !== this.editorData) {
                    this.editorData = this.value
                }
            }
        },
        created() {
            // 编辑器组件创建时将外部传入的值直接赋予编辑器
            this.editorData = this.value
        },
        mounted() {
            // 默认将编辑器禁用
            this.initTitle()
            this.$nextTick(() => {
                const button1 = document.querySelectorAll('.ql-questionblank')
                for (let btnDom of button1) {
                    btnDom.innerText = '[[]]'
                    btnDom.title = '插入输入框'
                }
                const button2 = document.querySelectorAll('.ql-kityformula')
                for (let btnDom of button2) {
                    btnDom.innerText = 'π'
                    btnDom.title = '插入公式'
                }
            })

            this.$refs.quillEditor.quill.getModule("toolbar").container.addEventListener("mousedown", (e) => {
                e.preventDefault();
                if(!this.$refs.quillEditor.quill.hasFocus()) {
                    this.$refs.quillEditor.quill.focus();
                }
            });

            this.timer = setInterval(()=> {
                if (this.meta && this.content !== null) {
                    this.$emit('blur', this.meta.question, this.meta.index, this.content)
                    this.content = null
                }
            }, 2000)
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer)
            }
        },
        methods: {
            setContents(content) {
                this.editorData = content
            },
            initTitle() {
                for (let item of titleConfig) {
                    const buttons = document.querySelectorAll('.quill-editor ' + item.Choice)
                    for (let btnDom of buttons) {
                        if (!btnDom) continue
                        btnDom.setAttribute('title', item.title)
                    }
                }
            },
            questionblankClose(data, len) {
                this.questionblankDialogVisible = false
                if (data) {
                    let quill = this.$refs.quillEditor.quill
                    let length = this.$refs.quillEditor.quill.selection.savedRange.index
                    quill.insertText(length || 0, data, {
                        'italic': false
                    });
                    quill.setSelection(length)
                }
            },
            kityformulaClose(data) {
                this.kityformulaDialogVisible = false
                let quill = this.$refs.quillEditor.quill
                let length = this.$refs.quillEditor.quill.selection.savedRange.index
                quill.insertEmbed(length, 'text', data)
                quill.setSelection(length + data.length)
            },
            handlePasteImg(node, delta) {
                let _self = this;
                try {
                    let base64code = delta && delta.ops && delta.ops[0] && delta.ops[0]['insert'] && delta.ops[0]['insert']['image'];

                    if (base64code) {
                        if (base64code.startsWith('http://') || base64code.startsWith('https')) {
                            return delta;
                        } else {
                            let file = _self.dataURLtoFile(base64code, 'paste.png');
                            let formData = new FormData();
                            formData.append("file", file);
                            _self.gUpload(formData, function (data) {
                                // 获取富文本对象
                                let quill = _self.$refs['quillEditor'].quill;
                                // 获取编辑器光标位置
                                let length = quill.selection.savedRange.index;
                                // 插入图片至光标位置，imgUrl为图片地址
                                quill.insertEmbed(length, 'image', data.uri);
                                // 移动光标至图片后面
                                quill.setSelection(length + 1);
                            });
                            // 1、等待请求返回做不到同步，先返回空，在请求回调中再添加
                            delta.ops = [];
                            return delta;
                        }
                    } else {
                        return delta;
                    }
                } catch (e) {
                    return delta;
                }
            },
            dataURLtoFile: function (dataurl, name) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], name, {type: mime});
            },
            // 网络处理：上传操作
            gUpload(params, callBack) {
                let url = "/api/file/common/upload";
                request.post(url, params, {
                    withCredentials: false,
                }).then(function (response) {
                    let data = response.data
                    if (response.status !== 200) {
                        console.log("error: ", response.message);
                    } else {
                        callBack(data);
                    }
                }).catch(function () {
                    console.log("截图上传失败");
                });
            },
            handleEditAble() {
                this.editable = true
            },
            onEditorBlur() {
                if (this.editable) {
                    // this.$emit('blur', this.html, this.meta)
                }
            },
            onEditorFocus(event) {
                if (!this.disabled) {
                    let doc = document.querySelectorAll('.ql-toolbar')
                    for (let i = 0; i < doc.length; i++) {
                        const e = doc[i];
                        e.style.display = 'none'
                    }
                    this.$refs.quillEditor.$el.children[0].style.display = 'block'
                    this.$emit('focus')
                }
            },
            onEditorChange(instance) {
                this.editorData = this.$refs.quillEditor._content
                this.content = instance.html;
                this.$emit('update:value', this.editorData);
            },
            questionblankHandler() {
                this.questionblankDialogVisible = true
            },
            kityformulaHandler() {
                this.kityformulaDialogVisible = true
            },
            handleSuccess(res) {
                // 获取富文本组件实例
                let quill = this.$refs.quillEditor.quill
                // 如果上传成功
                if (res) {
                    // 获取光标所在位置
                    let length = quill.getSelection().index;
                    // 插入图片，res为服务器返回的图片链接地址
                    quill.insertEmbed(length, 'image', res)
                    // 调整光标到最后
                    quill.setSelection(length + 1)
                } else {
                    this.$message({
                        type: 'error',
                        message: '上传失败'
                    });
                }
            },
        },
    }
</script>
<style>
    .ql-editor {
        overflow-x: auto !important;
    }

    .ql-container.ql-snow .ql-editor:focus {
        min-height: 200px !important;
        overflow-y: auto !important;
    }
</style>
<style scoped>
    .questionblankTag {
        background: #ddd;
    }

    .quill-editor >>> .ql-container.ql-disabled {
        background: #f5f7fa;
        cursor: not-allowed !important;
    }

    .quill-editor >>> .ql-toolbar.ql-snow .ql-formats {
        margin-right: 0px;
    }

    .quill-editor >>> .ql-toolbar {
        display: none;
        background: #fff;
        border-bottom: 0;
        border-radius: 4px 4px 0 0;
        border-color: #DCDFE6;
        padding: 0 8px;
        line-height: 40px;
    }

    .quill-editor >>> .ql-picker-options {
        z-index: 999;
    }

    .quill-editor >>> .ql-container {
        border: 1px solid #DCDFE6 !important;
        border-radius: 4px;
        max-height: 200px;
        overflow: auto;
    }

    .quill-editor:hover >>> .ql-container {
        border-radius: 0 0 4px 4px;
    }

    .quill-editor {
        position: relative;
        padding: 0;
        line-height: 0;
    }

    .quill-editor >>> .ql-editor {
        padding: 0;
        white-space: pre
    }

    .quill-editor >>> .ql-editor.ql-blank::before {
        font-style: normal;
        color: #C0C4CC;
    }

    .quill-editor >>> .ql-container .ql-editor {
        padding: 8px;
        line-height: 22px;
    }

    .quill-editor >>> .ql-snow .ql-color-picker .ql-picker-label svg, .quill-editor >>> .ql-snow .ql-icon-picker .ql-picker-label svg {
        right: 8px;
        position: absolute;
        top: 1px;
    }

    .quill-editor >>> .ql-toolbar .ql-questionblank {
        position: relative;
        line-height: 0;
        margin-bottom: 4px;
    }

    .quill-editor >>> .ql-toolbar .ql-kityformula {
        position: relative;
        font-size: 22px;
        top: -12px;
        display: none;
    }

    .quill-editor >>> .ql-toolbar.ql-snow .ql-picker-label::before {
        position: absolute;
    }

    .quill-editor >>> .ql-toolbar.ql-snow .ql-color-picker .ql-picker-label, .quill-editor >>> .ql-toolbar.ql-snow .ql-icon-picker .ql-picker-label {
        padding: 0px 4px;
    }

    .quill-editor >>> .ql-toolbar.ql-snow .ql-picker-label {
        margin-top: -1px;
    }

    .questionblankTag {
        background: #ddd;
    }

    .ivu-upload {
        display: none;
    }

    .ql-editor:after {
        content: '';
        height: 20px;
        clear: both;
        overflow: hidden;
        display: block;
        visibility: hidden;
    }
</style>
